var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3 common-department"},[(_vm.surveyFileItem)?_c('SurveyFile',{attrs:{"item":_vm.surveyFileItem},on:{"closeFileSection":_vm.closeFileSection}}):_c('SurveyAdminList',{on:{"openFileSection":_vm.openFileSection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }